import {
  RECEIVE_TOPIC_CAT_ITEM,
  RECEIVE_AREA_CAT_ITEM,
  RECEIVE_TOPIC_CAT_BOOK,
  RECEIVE_AREA_CAT_BOOK,
  RECEIVE_INDEX_AREA,
  RECEIVE_ITEM_LIST,
  READING_TYPE,
  RECEIVE_BOOK_ID,
  COUTER,
  RECEIVE_USER_INFO,
  SHOW_LOADING,
  HIDE_LOADING,
  FILTER_CATEGORY
} from './mutation-type.js'

export default {
  [RECEIVE_TOPIC_CAT_ITEM] (state, {data}) {
    state.topicCategorysItem = data
  },
  [RECEIVE_AREA_CAT_ITEM] (state, {data}) {
    state.areaCategorysItem = data
  },
  [RECEIVE_TOPIC_CAT_BOOK] (state, {data}) {
    state.topicCategorysBook = data
  },
  [RECEIVE_AREA_CAT_BOOK] (state, {data}) {
    state.areaCategorysBook = data
  },
  [RECEIVE_ITEM_LIST] (state, {data}) {
    state.itemList = data
  },
  [RECEIVE_INDEX_AREA] (state, {data}) {
    state.indexArea = data
  },
  [READING_TYPE] (state, {itemType}) {
    localStorage.setItem(`itemType`, JSON.stringify(itemType))
    state.readingType = itemType
  },
  [RECEIVE_BOOK_ID] (state, {bookId}) {
    localStorage.setItem(`bookId`, JSON.stringify(bookId))
    state.book_id = bookId
  },
  [COUTER] (state, {updataCouter}) {
    localStorage.setItem(`count`, JSON.stringify(updataCouter))
    state.upCouter = updataCouter
  },
  [RECEIVE_USER_INFO] (state, userinfo) {
    localStorage.setItem(`userinfo`, JSON.stringify(userinfo))
    state.userinfo = userinfo
  },
  [SHOW_LOADING] (state) {
    state.LOADING = true
  },
  [HIDE_LOADING] (state) {
    state.LOADING = false
  },
  [FILTER_CATEGORY] (state, {categoryArr}) {
    localStorage.setItem(`filterList`, JSON.stringify(categoryArr))
    state.filterList = categoryArr
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js